












import { mapActions, mapGetters } from 'vuex';
import Proxyable from '@/mixins/proxyable';

export default Proxyable.extend({
  name: 'SalesRepPicker',
  data: () => ({
    loading: false
  }),

  computed: {
    ...mapGetters({
      salesReps: 'salesRep/getSalesReps'
    })
  },

  mounted() {
    this.loading = true;
    this.fetchSalesReps().finally(() => (this.loading = false));
  },

  methods: {
    ...mapActions({
      fetchSalesReps: 'salesRep/fetchSalesReps'
    })
  }
});
